<nb-card class="importar-recintos-dialog" [nbSpinner]="loading || cargandoDatos"
    nbSpinnerStatus="danger"
    nbSpinnerSize="large"
    [nbSpinnerMessage]="mensajeSpinner">

  <nb-card-header>
    Importar Recintos
  </nb-card-header>


  <nb-card-body  >

    <p>
      Añada los recintos que desea importar.
    </p>

    <p>
      El campo a rellenar, IDSIGPAC, debe tener el formato:
    </p>

    <p>
      <strong>
        PROVINCIA, MUNICIPIO, AGREGADO, ZONA,
        POLÍGONO, PARCELA, RECINTO
      </strong>
    </p>

    <p>
      Ejemplo:
      <strong>16,254,0,0,10,138,1</strong>
    </p>

    <div
      class="linea-recinto"
      *ngIf="!cargandoDatos">

      <!-- IDSIGPAC -->

      <div class="idsigpac-container">

        <input
          nbInput
          fullWidth
          type="text"
          [(ngModel)]="idsigpac"
          [disabled]="loading"
          placeholder="IDSIGPAC"
        />

      </div>

      <!-- CULTIVO -->

      <div class="cultivo-container">

        <nb-select
          fullWidth
          placeholder="Cultivo"
          [(selected)]="cultivoSeleccionado"
          [disabled]="loading"
          (selectedChange)="cambioCultivo()">

          <nb-option
            *ngFor="let cultivo of cultivos"
            [value]="cultivo.identifier">

            {{ cultivo.name }}

          </nb-option>

        </nb-select>

      </div>


      <!-- VARIEDAD -->

      <div class="variedad-container">

        <nb-select
          fullWidth
          placeholder="Variedad"
          [(selected)]="variedadSeleccionada"
          [disabled]="
            loading ||
            cultivoSeleccionado == null
          ">

          <nb-option
            *ngFor="
              let variedad of variedadesFiltradas
            "
            [value]="variedad.identifier">

            {{ variedad.name }}

          </nb-option>

        </nb-select>

      </div>


      <!-- AÑADIR -->

      <button
        nbButton
        status="primary"
        [disabled]="!puedeAnadirRecinto"
        (click)="anadirRecinto()">

        Añadir

      </button>

    </div>


    <!--
      LISTADO DE CHIPS
    -->

    <div
      class="chips-recintos"
      *ngIf="recintos.length > 0">

      <div
        class="recinto-chip"
        *ngFor="let recinto of recintos">

        <span>
          {{ recinto.idsigpac }}
        </span>

        <span class="separador">
          -
        </span>

        <span>
          {{ recinto.cultivo }}
        </span>

        <span class="separador">
          -
        </span>

        <span>
          {{ recinto.variedad }}
        </span>

        <button
          type="button"
          class="remove-chip"
          [disabled]="loading"
          (click)="eliminarRecinto(recinto)">

          ×

        </button>

      </div>

    </div>


    <!--
      INDICADOR DURANTE LA IMPORTACIÓN
    -->

    <div
      class="loading-container"
      *ngIf="loading">

      <p>
        La importación de recintos puede tardar
        varios minutos.
      </p>

      <p>
        No cierre esta ventana mientras se está
        realizando la importación.
      </p>

    </div>

  </nb-card-body>


  <nb-card-footer>

    <button
      nbButton
      status="basic"
      [disabled]="loading"
      (click)="cerrar()">

      CERRAR

    </button>


    <button
      nbButton
      status="primary"
      [disabled]="
        loading ||
        recintos.length === 0
      "
      (click)="importar()">

      IMPORTAR

    </button>

  </nb-card-footer>

</nb-card>
